import { render, staticRenderFns } from "./AllEventsPosts.vue?vue&type=template&id=20f0879e"
import script from "./AllEventsPosts.vue?vue&type=script&lang=js"
export * from "./AllEventsPosts.vue?vue&type=script&lang=js"
import style0 from "./AllEventsPosts.vue?vue&type=style&index=0&id=20f0879e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports